import { ProfileFormValues } from './utils'
import { pick } from 'lodash'

export const STORAGE_KEY_BASENAME = 'formDraftUser'

export const saveDraftToLocalStorage = (
  values: ProfileFormValues,
  userId: number
) => {
  const encodedData = JSON.stringify(values)
  localStorage.setItem(`${STORAGE_KEY_BASENAME}:${userId}`, encodedData)
}

export const deleteDraftFromLocalStorage = (userId: number) => {
  localStorage.removeItem(`${STORAGE_KEY_BASENAME}:${userId}`)
}

const testJson = (jsonString: string) => {
  try {
    const parsed: Record<string, unknown> = JSON.parse(jsonString)
    return parsed
  } catch {
    return null
  }
}

export const restoreDraftFromLocalStorage = (
  userId: number,
  formEmptyValues: ProfileFormValues
): ProfileFormValues => {
  const storedJsonString = localStorage.getItem(
    `${STORAGE_KEY_BASENAME}:${userId}`
  )

  const savedData =
    storedJsonString && testJson(storedJsonString)
      ? JSON.parse(storedJsonString || JSON.stringify({}))
      : {}

  // from saved object we take only the keys available from formEmptyValues
  const validFormValues = pick(
    savedData,
    Object.keys(formEmptyValues)
  ) as ProfileFormValues

  const validFormValuesWithParsedDate: ProfileFormValues = {
    ...validFormValues,
    company_cciaa_date: validFormValues.company_cciaa_date
      ? new Date(validFormValues.company_cciaa_date)
      : null,

    company_date_start: validFormValues.company_date_start
      ? new Date(validFormValues.company_date_start)
      : null,

    holder_address: {
      ...validFormValues.holder_address,
      birth_date:
        validFormValues.holder_address &&
        validFormValues.holder_address.birth_date
          ? new Date(validFormValues.holder_address.birth_date)
          : null,
    },

    technical_director_address: {
      ...validFormValues.technical_director_address,
      birth_date:
        validFormValues.technical_director_address &&
        validFormValues.technical_director_address.birth_date
          ? new Date(validFormValues.technical_director_address.birth_date)
          : null,
    },

    technical_manager_address: {
      ...validFormValues.technical_manager_address,
      birth_date:
        validFormValues.technical_manager_address &&
        validFormValues.technical_manager_address.birth_date
          ? new Date(validFormValues.technical_manager_address.birth_date)
          : null,
    },
  }

  // returning formEmptyValues filled with valid keys found from local storage
  return {
    ...formEmptyValues,
    ...validFormValuesWithParsedDate,
  }
}
